// extracted by mini-css-extract-plugin
module.exports = {"favorite":"QKcoJKKj","sticky":"saVVUuRu","show":"ggn1bx2A","title":"UGElhCVJ","header":"CRdjL1j4"};